import { MyAreaCategoryFilterProps } from '@msc-b2c/interfaces/types';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppDispatch,
  initialCategoryFilters,
  RootState,
  toggleCategoryFilter,
} from '@msc-b2c/shared-utils';
import { CategoryFilter } from './CategoryFilter';

export function CategoryFilterWrapper({
  categoryFilterTitle,
  categoryFilters,
}: Readonly<MyAreaCategoryFilterProps>) {
  const dispatch = useDispatch<AppDispatch>();
  // dispatch initial category filters
  dispatch(initialCategoryFilters(categoryFilters));

  const dynamicCategoryFilters = useSelector(
    (state: RootState) => state.myAreaFilter.categoryFilters?.filtered
  );
  const isButtonsDisabled = useSelector((state: RootState) => state.myAreaFilter.isButtonsDisabled);

  function handleCheckboxChange(index: number) {
    dispatch(toggleCategoryFilter(index));
  }

  return (
    <CategoryFilter
      categoryFilterTitle={categoryFilterTitle}
      isButtonsDisabled={isButtonsDisabled}
      handleCheckboxChange={handleCheckboxChange}
      categoryFilters={dynamicCategoryFilters}
    />
  );
}

export default CategoryFilterWrapper;

CategoryFilterWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/categoryfilter';
